import React from "react";
import Page from "../components/Page";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingPage from "./LoadingPage";
import LoginPage from "./LoginPage";

function NewslettersPage() {
  const { data } = useSelector((state) => state.cms);
  const { user } = useSelector((state) => state.auth);
  
  const collectionSlug = "newsletters";
  const newsletters = data[collectionSlug];

  if (!user) return <LoginPage />;
  if (!newsletters) return <LoadingPage />;

  // Helper function to check if newsletter is accessible to user
  const isNewsletterAccessible = (newsletter) => {
    const newsletterRoles = newsletter.attributes.role || [];
    return newsletterRoles.some(roleObj => 
      roleObj.Role === "Public" || roleObj.Role === user.currentRole
    );
  };

  // Filter accessible newsletters
  const accessibleNewsletters = newsletters.filter(isNewsletterAccessible);

  // Separate newsletters by type
  const publicNewsletters = newsletters.filter(newsletter => 
    newsletter.attributes.role?.some(roleObj => roleObj.Role === "Public")
  );

  const roleSpecificNewsletters = newsletters.filter(newsletter => 
    newsletter.attributes.role?.some(roleObj => 
      roleObj.Role === user.currentRole && roleObj.Role !== "Public"
    )
  );

  const NewsletterCard = ({ newsletter }) => (
    <Link 
      to={`/newsletters/${newsletter.id}`} 
      className="container fillwhite containerpadding w-container"
      style={{ 
        textDecoration: 'none', 
        marginBottom: '20px',
        display: 'block',
      }}
    >
      <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
        {newsletter.attributes.photo && 
         newsletter.attributes.photo.data && (
          <div style={{ flexShrink: 0 }}>
            <img 
              src={newsletter.attributes.photo.data.attributes.url} 
              alt="" 
              className="imagerounded"
              style={{
                width: '300px',
                height: '200px',
                objectFit: 'cover'
              }}
            />
          </div>
        )}
        <div>
          <h3 className="textcenter" style={{ margin: '0 0 10px 0' }}>
            {newsletter.attributes.title}
          </h3>
          <p style={{ margin: '0' }}>
            {newsletter.attributes.body.substring(0, 200)}...
          </p>
        </div>
      </div>
    </Link>
  );

  return (
    <Page data-wf-page="635934a8e598deacd00a5b71" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="container w-container">
          <h1>Newsletters</h1>
        </div>
      </div>

      {/* Public Newsletters Section */}
      {publicNewsletters.length > 0 && (
        <div className="section wf-section">
          <div className="container w-container">
            <h2>Public Newsletters</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {publicNewsletters.map((newsletter) => (
                <NewsletterCard key={newsletter.id} newsletter={newsletter} />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Role-specific Newsletters Section */}
      {roleSpecificNewsletters.length > 0 && (
        <div className="section wf-section">
          <div className="container w-container">
            <h2>Internal Only Newsletters</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {roleSpecificNewsletters.map((newsletter) => (
                <NewsletterCard key={newsletter.id} newsletter={newsletter} />
              ))}
            </div>
          </div>
        </div>
      )}
    </Page>
  );
}

export default NewslettersPage;